import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Message extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Message'
  // Define default properties here
  static instanceDefaults() {
    return {
      member_id: null,
      group_id: null,
      action_id: null,
      message: {},
      elaborated: null,
      data: {},
      read: false,
      starred: false,
      completed: false,
      approved: false,
      status: null,
      reference: null,
      properties: {},
      created_at: null
    }
  }
}

const servicePath = 'messages'
const servicePlugin = makeServicePlugin({
  Model: Message,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [ctx => {
      console.log('BEFORE find', ctx.params.query)
      return ctx
    }],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin